import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { SearchPlaceIndexForPositionRequestFilterSensitiveLog, SearchPlaceIndexForPositionResponseFilterSensitiveLog, } from "../models/models_0";
import { de_SearchPlaceIndexForPositionCommand, se_SearchPlaceIndexForPositionCommand, } from "../protocols/Aws_restJson1";
export { $Command };
export class SearchPlaceIndexForPositionCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("LocationService", "SearchPlaceIndexForPosition", {})
    .n("LocationClient", "SearchPlaceIndexForPositionCommand")
    .f(SearchPlaceIndexForPositionRequestFilterSensitiveLog, SearchPlaceIndexForPositionResponseFilterSensitiveLog)
    .ser(se_SearchPlaceIndexForPositionCommand)
    .de(de_SearchPlaceIndexForPositionCommand)
    .build() {
}
